const baseUrl = "/api/social_collect"

const SocialCollectEntity = (authClient) => ({
  show: async () => await authClient.get(baseUrl),
  progress: async () => await authClient.get(`${baseUrl}/progress`),
  put: async (data) => await authClient.put(baseUrl, { social_collect: data }),
})

export default SocialCollectEntity
